
import { Component, Vue } from 'vue-property-decorator';
import { useStore } from 'vuex-simple';
import { UiButton } from '@fe/common/components';

import type { RootModule } from '../../core';

const STORAGE_KEY = 'UMP_CONSENT_NOTIFICATION';
const POPUP_TIMEOUT_TIME = 30000;

@Component({
  name: 'CookiesPopup',
  components: {
    UiButton
  }
})
export default class CookiesPopup extends Vue {
  isVisible = false;
  isSticky = false;
  hideNotificationTimeout: number | null = null;

  policyUrl = 'https://www.fontanka.ru/__site/cookie-policy/';

  store = useStore<RootModule>(this.$store);

  get isMobile() {
    return this.store.baseInfo.isMobile;
  }

  setHideNotificationTimeout() {
    this.hideNotificationTimeout = window.setTimeout(() => {
      this.isVisible = false;
    }, POPUP_TIMEOUT_TIME);
  };

  clearHideNotificationTimeout() {
    if (this.hideNotificationTimeout) {
      clearTimeout(this.hideNotificationTimeout);
      this.hideNotificationTimeout = null;
    }
  };

  showPopup() {
    this.isVisible = true;
    sessionStorage.setItem(STORAGE_KEY, 'true');

    this.sendEventViewPopupCookies();
    this.setHideNotificationTimeout();
  };

  handleScroll() {
    if (window.scrollY > 36 && !this.isVisible) {
      this.isSticky = true;
      this.showPopup();

      window.removeEventListener('scroll', this.handleScroll);
    }
  };

  onAgree() {
    localStorage.setItem(STORAGE_KEY, 'true');
    this.isVisible = false;

    this.sendEventClickPopupCookiesButton();
    this.clearHideNotificationTimeout();
  };

  sendEventViewPopupCookies() {
    this.sendYMParams(null, 'Просмотр', 'viewPopupCookies');
  };
  sendEventClickPopupCookiesButton() {
    this.sendYMParams('Согласие', 'Клик', 'clickPopupCookiesButton');
  };
  sendEventClickCookiesDocs() {
    this.sendYMParams('Документы', 'Клик', 'clickPopupCookiesDocs');
  };

  sendYMParams(
    value: string | Record<string, string | Record<string, string>> | null,
    fieldType: string,
    goalName: string
  ) {
    const url = location.origin + location.pathname;
    const params = value ? {
      ['Соглашение на обработку кукис']: {
        [fieldType]: {
          [url]: value
        }
      }
    } : {
      ['Соглашение на обработку кукис']: {
        [url]: `${fieldType}`
      },
    };
    this.$root.$emit('sendYaParams', { params, goalName });
  };

  mounted() {
    const hidePopup =
      localStorage.getItem(STORAGE_KEY) === 'true' || sessionStorage.getItem(STORAGE_KEY) === 'true';

    if (hidePopup) {
      return;
    }

    if (this.isMobile) {
      window.addEventListener('scroll', this.handleScroll);
    } else {
      this.showPopup();
    }
  }
}
